import { render } from "./SortHeaderComp.vue?vue&type=template&id=8143ddc8&scoped=true&ts=true"
import script from "./SortHeaderComp.vue?vue&type=script&lang=ts"
export * from "./SortHeaderComp.vue?vue&type=script&lang=ts"

import "./SortHeaderComp.vue?vue&type=style&index=0&id=8143ddc8&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\Code\\VSProjects\\modboxProject\\modbox\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8143ddc8"]])

export default __exports__